<section class="similar-jobs" *ngIf="viewModel$ | async as viewModel">
  <ng-container *ngIf="viewModel.showSection">
  <header>
    <h2 *ngIf="viewModel.loading; else title" class="similar-jobs-loading">
      <i class="pi pi-spin pi-spinner"></i> Looking for similar jobs...
    </h2>
    <ng-template #title>
      <h2>Similar jobs</h2>
    </ng-template>
    <div class="link-buttons" *ngIf="!viewModel.loading">
      <ng-container
        *ngFor="let linkButton of viewModel.linkButtons; last as isLast"
      >
        <span
          class="freya-link-button"
          *ngIf="linkButton.action"
          (click)="store.dispatch(linkButton.action())"
        >
          <i [class]="linkButton.icon"></i>
          {{ linkButton.label }}
        </span>
        <a
          class="freya-link-button"
          *ngIf="!linkButton.action"
          [routerLink]="linkButton.routerLink"
          [queryParams]="linkButton.queryParams"
          target="_blank"
        >
          <i [class]="linkButton.icon"></i>
          {{ linkButton.label }}
        </a>
        <span class="link-button-separator" *ngIf="!isLast">&#9679;</span>
      </ng-container>
    </div>
  </header>

  <div
    class="similar-jobs-list"
    [class.expanded]="viewModel.showMore"
    *ngIf="viewModel.showResults"
  >
      <div
        class="similar-jobs-row"
        *ngFor="let row of viewModel.rows; trackBy: trackById"
        (click)="store.dispatch(actions.jobRowClicked({ jobId: row.id }))"
      >
          <div class="cell customer">
            <div class="customer-name">{{ row.customer }}</div>
            <div class="customer-meta">
              <app-job-status-pill
                [state]="row.state"
                [stage]="row.stage"
                [label]="row.status"
              ></app-job-status-pill>
              <span class="relative-edited">Last edited {{ row.relativeEdited }}</span>
            </div>
          </div>
          <div class="cell actions">
            <button
              pButton
              label="Select"
              icon="pi pi-arrow-right"
              iconPos="right"
              class="p-button-outlined p-button-sm similar-job-action"
              (click)="$event.stopPropagation(); selectedRow = row; showSelectDialog = true"
            ></button>
          </div>
      </div>
      <div class="show-more-overlay" *ngIf="viewModel.showMoreButton">
        <button
          pButton
          [label]="viewModel.showMore ? 'Show Fewer' : 'Show More'"
          [icon]="viewModel.showMore ? 'pi pi-angle-double-up' : 'pi pi-angle-double-down'"
          class="p-button-text p-button-sm show-more-btn"
          (click)="store.dispatch(actions.showMoreClicked())"
        ></button>
      </div>
  </div>

  <p-dialog
    header="Select from similar job"
    [(visible)]="showSelectDialog"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '34rem' }"
  >
    <p class="select-dialog-intro" *ngIf="selectedRow">
      Found a similar job with <strong>{{ selectedRow.customer }}</strong>.
      Choose how to proceed:
    </p>
    <div class="select-panel">
      <button
        pButton
        class="select-option p-button-text"
        (click)="showSelectDialog = false; store.dispatch(actions.openCustomerButtonClicked({ jobId: selectedRow!.id, zoneId: selectedRow!.zoneId }))"
      >
        <i class="pi pi-user select-option-icon"></i>
        <div class="select-option-text">
          <span class="select-option-label">Select repeat customer {{ selectedRow?.customer }}</span>
          <span class="select-option-desc">Load this customer into the new opportunity form</span>
        </div>
      </button>
      <button
        pButton
        class="select-option p-button-text"
        (click)="showSelectDialog = false; store.dispatch(actions.openSimilarJobDirectly({ jobId: selectedRow!.id, zoneId: selectedRow!.zoneId }))"
      >
        <i class="pi pi-file-import select-option-icon"></i>
        <div class="select-option-text">
          <span class="select-option-label">Select existing job {{ selectedRow?.code }}</span>
          <span class="select-option-desc">Open this existing job for editing</span>
        </div>
      </button>
    </div>
  </p-dialog>

  <div class="similar-jobs-list" *ngIf="viewModel.showEmptyState && !viewModel.loading">
    <div class="empty-row" *ngFor="let placeholder of [0, 1]">
      <div class="empty-placeholder"></div>
    </div>
  </div>
  </ng-container>
</section>
